import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { CloseOutline, ScreenOutline } from '../../../../icons/icons';
import { useAppDispatch, useAppSelector } from '../../../hooks/store-hooks';
import { closeAllWindows } from '../../../state/slices/workspace-slice';

export function ExternalWindowsCloseButton() {
    const count = useAppSelector((x) => x.workspace.windows.length);
    const [hover, setHover] = React.useState(false);
    const dispatch = useAppDispatch();

    if (count === 0) {
        return <></>;
    }

    return (
        <div className="position-relative">
            <Button
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                svgIcon={hover ? CloseOutline : ScreenOutline}
                style={{ width: 27, height: 27 }}
                className="k-rounded-full"
                data-tooltip-bottom
                title="Close all windows"
                onClick={() => dispatch(closeAllWindows())}
            />
            <div
                style={{
                    fontSize: '0.60rem',
                    position: 'absolute',
                    right: -6,
                    bottom: -4,
                    background: 'var(--fe-primary)',
                    color: 'white',
                    lineHeight: 1,
                    borderRadius: '50%',
                    minWidth: '1em',
                    padding: '0.3em 0.3em',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                {count}
            </div>
        </div>
    );
}
